var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAiBuilder = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 19,
  viewBox: "0 0 22 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 1.5,
  y: 14.5,
  width: 19,
  height: 4,
  rx: 1.5,
  stroke: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 8V13",
  stroke: "currentColor",
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 8V13",
  stroke: "currentColor",
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M5 8V13",
  stroke: "currentColor",
  strokeLinecap: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M9 8V13",
  stroke: "currentColor",
  strokeLinecap: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M9 8V13",
  stroke: "currentColor",
  strokeLinecap: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M9 8V13",
  stroke: "currentColor",
  strokeLinecap: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M13 8V13",
  stroke: "currentColor",
  strokeLinecap: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M13 8V13",
  stroke: "currentColor",
  strokeLinecap: "round"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M13 8V13",
  stroke: "currentColor",
  strokeLinecap: "round"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M17 8V13",
  stroke: "currentColor",
  strokeLinecap: "round"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M17 8V13",
  stroke: "currentColor",
  strokeLinecap: "round"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M17 8V13",
  stroke: "currentColor",
  strokeLinecap: "round"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.4601 3.79892L11.3089 1.15174C11.1081 1.08654 10.8919 1.08654 10.6911 1.15174L2.53994 3.79892C1.45677 4.15069 1.70996 5.75002 2.84882 5.75002H19.1512C20.2901 5.75002 20.5432 4.15069 19.4601 3.79892ZM11.6178 0.200642C11.2162 0.0702451 10.7838 0.0702451 10.3822 0.200642L2.23106 2.84782C0.0647215 3.55136 0.571105 6.75002 2.84882 6.75002H19.1512C21.4289 6.75002 21.9353 3.55136 19.7689 2.84782L11.6178 0.200642Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAiBuilder);
export { ForwardRef as ReactComponent };